import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import connectionReducer from './slices/connectionSlice';
import chatReducer from './slices/chatSlice';
import ticketReducer from './slices/ticketSlice';
import notificationReducer from './slices/notificationSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    connection: connectionReducer,
    chat: chatReducer,
    ticket: ticketReducer,
    notification: notificationReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['auth/setUser'],
        // Ignore these paths in the state
        ignoredPaths: ['auth.user.createdAt', 'auth.user.lastActivity']
      }
    })
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;